import {createContext} from 'react';

export const GlobalSite=createContext()